import React, { useState, useCallback } from 'react'
import { db } from './Connections'
import { collection, addDoc } from 'firebase/firestore'
import ContactModal from './components/ContactModal'
import Hero from './components/Hero'
import ProductSection from './components/ProductSection'
import ContactStrip from './components/ContactStrip'
import { visibilityProducts, gameProducts, securityProducts } from './data/products'
import './global.css'

function App() {
  const [modalOpen, setModalOpen] = useState(false)

  const handleOpenModal = useCallback(() => setModalOpen(true), [])
  const handleCloseModal = useCallback(() => setModalOpen(false), [])

  const handleSubmit = useCallback(async (data) => {
    const today = new Date().toLocaleString('pt-BR')
    const docRef = await addDoc(collection(db, 'feedbacks'), {
      name: data.nome,
      contato: data.contato,
      feed: data.mensagem,
      data: today,
    })
    console.log('Document written with ID:', docRef.id)
  }, [])

  return (
    <div className="app">
      <ContactModal
        open={modalOpen}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
      />

      <Hero onContactClick={handleOpenModal} />

      <main className="content">
        <ProductSection
          label="Mais visibilidade — modelos prontos"
          products={visibilityProducts}
        />
        <ProductSection
          label="Jogos e diversão — modelos prontos"
          products={gameProducts}
        />
        <ProductSection
          label="Cibersegurança"
          products={securityProducts}
        />

        <ContactStrip onContactClick={handleOpenModal} />
      </main>
    </div>
  )
}

export default App
